var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M243.52 38.057h-5.306c-.563 0-1.02-.46-1.02-1.028 0-.568.457-1.029 1.02-1.029h7.767c.563 0 1.019.46 1.019 1.029v7.714c0 .568-.456 1.028-1.02 1.028-.562 0-1.019-.46-1.019-1.028v-5.231l-8.614 8.692a1.013 1.013 0 0 1-1.442 0 1.035 1.035 0 0 1 0-1.454l8.615-8.693zm-1.268 8.389c0-.568.456-1.029 1.019-1.029s1.02.46 1.02 1.029v4.743c0 1.552-1.248 2.811-2.787 2.811h-9.718c-1.539 0-2.786-1.259-2.786-2.811v-9.806c0-1.553 1.247-2.812 2.786-2.812h4.729c.563 0 1.02.46 1.02 1.029 0 .568-.457 1.029-1.02 1.029h-4.729a.75.75 0 0 0-.747.754v9.806a.75.75 0 0 0 .747.754h9.718a.75.75 0 0 0 .748-.754v-4.743z","transform":"translate(-229 -36)"}));
}

ExternalLink.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
